import styled from 'styled-components';

export const OsSelectionStyled = styled.div`
  .deviceOsSelection {
    &__tableContainer { // todo delete all of this custom styles whenever needed
      &__tableData {
        table {
          box-sizing: border-box;
          padding: 12px;
          background-color: ${props => props.theme.uiColors.background01};
        }
        .listTbodyRow {
          font-family: ${props => props.theme.fontRegular};
        }
        .compactPagination {
          background-color: ${props => props.theme.uiColors.background01};
        }
      }
      .deviceOsEntry {
        font-size: ${props => props.theme.fontSizeS};
        font-family: ${props => props.theme.fontBold};
      }
    }
  }
`;
